import { twMerge } from 'tailwind-merge'

export const baseAttachmentClassName = (canRemove: boolean) =>
  twMerge(
    'min-w-7 group/attachment flex h-7 w-fit flex-shrink-0 cursor-default items-center gap-1.5 rounded-[10px] border border-transparent px-2',
    // Soft white pill with a hairline shadow (input-bar chip language).
    'bg-background shadow-xs',
    'font-normal text-foreground-secondary hover:text-foreground transition-colors duration-200 hover:bg-element',
    !canRemove &&
      'bg-element hover:bg-element border-border text-foreground-secondary hover:text-foreground shadow-none',
    'max-w-36',
  )

export const baseIconClassName = 'flex-shrink-0 opacity-90'

export const scrollablePreviewClassName = 'font-normal max-w-64 flex max-h-48 flex-col gap-3 p-3 py-2 text-[13px]'

export const scrollableAreaClassName =
  'text-foreground-placeholder flex h-full flex-col gap-2 text-ellipsis whitespace-pre-line leading-normal'
